import { FC } from "react";
import Image from "next/legacy/image";
import AdvisorTeamActionButtons from "@modules/advisory-team/components/AdvisorTeamActionButtons";
import { Typography } from "@earned/core";
import Earned from "@images/earned.png";

interface Props {
  advisor?: Forme.AdvisorWithRole;
  advisorName: string;
  isLockedAdvisoryTeam: boolean;
}

const AdvisorCard: FC<Props> = ({
  advisor,
  advisorName,
  isLockedAdvisoryTeam,
}) => {
  const advisorImage = advisor?.headshotUrl || Earned;
  const hasImage = Boolean(advisorImage);

  return (
    <div className="w-full sm:w-auto">
      <div
        className={`mb-7 flex flex-none flex-col rounded border border-green-200 last:mb-0 sm:flex-row md:mb-7 md:w-full lg:mb-0 lg:w-[480px] lg:flex-row`}
      >
        <div className="flex h-[118px] w-full justify-center rounded-t bg-offwhite p-6 pb-0 sm:h-auto sm:w-32 lg:rounded-bl lg:rounded-tl lg:rounded-tr-none ">
          {hasImage && (
            <div>
              <Image
                src={advisorImage}
                alt="profile picture"
                width={80}
                height={80}
                className="rounded-full"
              />
            </div>
          )}
        </div>
        <div className="flex flex-1 flex-col items-center p-6 sm:items-start">
          <Typography variant="body-xl" weight="medium" color="primary">
            {advisorName}
          </Typography>
          <div className="flex min-h-10 flex-col items-center sm:items-start">
            <Typography variant="body-sm" weight="medium" color="primary">
              {advisor?.credentials}
            </Typography>
            <Typography variant="body-sm" color="primary" weight="medium">
              {advisor?.title}
            </Typography>
          </div>
          <AdvisorTeamActionButtons
            advisorTeamMemberInfo={advisor}
            isLockedAdvisoryTeam={isLockedAdvisoryTeam}
          />
        </div>
      </div>
    </div>
  );
};

export default AdvisorCard;
